import OrderDetailsComponent from 'modules/shared/orders/components/OrderDetailsComponent';

const OrderDetailsContainer = props => <OrderDetailsComponent {...props} />;

OrderDetailsContainer.propTypes = {};

OrderDetailsContainer.defaultProps = {};

export default OrderDetailsContainer;
